import React from "react";
import { Card, Col } from "react-bootstrap";

interface QuestionState {
  question: any;
}
const AssessmentCardQuestion = ({ question }: QuestionState) => {
  return (
    <Card>
      <Card.Body className="py-2">
        <Col xs={12}>{question?.question}</Col>
      </Card.Body>
    </Card>
  );
};

export default AssessmentCardQuestion;
